function Interests() {
    return (
        <div>Interests Page</div>
    )
}

export default Interests;